export interface InterestScore {
  interestId: number;
  interestName: string;
  abbreviation: string;
  score: number;
}

/**
 * Returns the interestId integers (1-6) of the top two RIASEC traits for an
 * occupation, ordered highest-score-first.
 *
 * Handles both standard Occupation (interestScore on root) and CustomOccupation
 * (interestScore is null; falls back to parentOccupation.interestScore).
 *
 * Always uses interestId integers for identification -- never trait name strings.
 * The gateway uses "Enterprise" while PathBuilder uses "Enterprising"; numeric
 * IDs are consistent across both systems.
 *
 * Returns [] when no interestScore data is available, so callers can treat
 * the occupation as having no interest match data (safe default: null fit).
 */
export const getTopTwoTraitIds = (occupation: any): number[] => {
  if (!occupation) {
    return [];
  }

  const scores: InterestScore[] =
    occupation.interestScore?.length
      ? occupation.interestScore
      : occupation.parentOccupation?.interestScore ?? [];

  if (!scores.length) {
    return [];
  }

  return [...scores]
    .sort((a, b) => b.score - a.score)
    .slice(0, 2)
    .map(s => s.interestId);
};
